import React from 'react';

/**
 * Error boundary component for message pin system
 * Prevents entire map from crashing if pin processing fails
 */
class MessagePinErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error for debugging
    console.error('Message Pin Error Boundary caught an error:', error, errorInfo);
    
    // Could send to error reporting service here
    // Example: logErrorToService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI when pins fail
      return (
        <div className="message-pin-error-fallback">
          {/* Render nothing - just hide pins gracefully */}
          {this.props.showErrorMessage && (
            <div className="fixed bottom-4 right-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded z-50">
              <p className="text-sm">
                Photo pins temporarily unavailable
              </p>
            </div>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default MessagePinErrorBoundary;
